import { z } from "zod";
import { bookProductionProductSchema } from "./book-production-evidence.js";
export const BOOK_PRODUCTION_MEDIA_MANIFEST_CONTRACT = "BOOK_PRODUCTION_MEDIA_MANIFEST_V1";
const safeId = z.string().trim().min(1).max(240);
const sha256 = z.string().regex(/^[a-f0-9]{64}$/u);
export const bookProductionMediaManifestEntryV1Schema = z
    .object({
    sourceId: safeId,
    artifactBindingId: safeId,
    assetId: safeId,
    storage: z.enum(["MEDIA", "PRINT"]),
    objectKey: z
        .string()
        .trim()
        .min(1)
        .max(1_024)
        .refine((value) => !value.startsWith("/") && !value.includes("..")),
    objectVersionId: z.string().trim().min(1).max(1_024),
    checksumSha256: sha256,
    byteSize: z
        .number()
        .int()
        .positive()
        .max(100 * 1024 * 1024),
    contentType: z.enum(["image/jpeg", "image/png"]),
    altText: z.string().trim().min(1).max(2_000),
    placement: z.enum(["HERO", "PANEL", "PORTRAIT", "PROCESS", "ARTIFACT"]),
})
    .strict();
export const bookProductionMediaManifestV1Schema = z
    .object({
    contract: z.literal(BOOK_PRODUCTION_MEDIA_MANIFEST_CONTRACT),
    manifestId: safeId,
    bookId: safeId,
    sourceRevision: z.number().int().nonnegative(),
    product: bookProductionProductSchema,
    revision: z.number().int().positive(),
    entries: z.array(bookProductionMediaManifestEntryV1Schema).max(200),
    createdBy: safeId,
    createdAt: z.string().datetime({ offset: true }),
    truthBoundary: z.literal("CURRENT_APPROVED_MEDIA_IDENTITIES_NOT_RENDER_PRINT_APPROVAL_PROVIDER_AUTHORITY_OR_PHYSICAL_PROOF"),
})
    .strict()
    .superRefine((manifest, context) => {
    for (const [path, values] of [
        ["sourceId", manifest.entries.map(({ sourceId }) => sourceId)],
        ["artifactBindingId", manifest.entries.map(({ artifactBindingId }) => artifactBindingId)],
    ])
        if (new Set(values).size !== values.length)
            context.addIssue({
                code: "custom",
                path: ["entries"],
                message: `Production media ${path} values must be unique.`,
            });
});
//# sourceMappingURL=book-production-media-manifest.js.map